import axios from "axios";
import { getConfig } from "../../../../ApiHelpers/ApiDefaultConfig";
import { GetCbuResponse } from "./models";

export const getCbuInformation = async (): Promise<GetCbuResponse | null> => {
    let config = getConfig()
    let result: GetCbuResponse | null = null
    try {
        await axios.get(`/getCbu`, config)
            .then((res) => {
                result = res.data || {}
            })
    } catch (error) {
        console.log(error)
    }

    return result
}

export const updateCbuInformation = async (cbuData: GetCbuResponse): Promise<boolean> => {
    let config = getConfig()
    try {
        await axios.post(`/editCBU`, cbuData, config)
        return true
    } catch (error) {
        console.log(error)
        return false
    }
}
